// Parse a YYYY-MM-DD date string as a local-time date, avoiding the UTC-midnight
// parsing that `new Date(dateStr)` does for date-only strings (which then drifts
// a day off when normalized to local midnight in timezones behind UTC).
const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const calculateDaysInFoal = (record) => {
  if (!record.breeding_date) {
    return null;
  }

  try {
    const breedingDate = parseLocalDate(record.breeding_date);
    const endDate = record.actual_foaling_date
      ? parseLocalDate(record.actual_foaling_date)
      : new Date();

    // Set time to midnight to avoid timezone issues
    breedingDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const diffTime = endDate - breedingDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  } catch (error) {
    console.error('Error calculating days in foal:', error);
    return null;
  }
};

export const formatMonthsAndDays = (days) => {
  if (days === null || days < 0) {
    return null;
  }

  if (days === 0) {
    return '0 days';
  }

  const months = Math.floor(days / 30);
  const remainingDays = days % 30;

  if (months === 0) {
    return `${remainingDays} ${remainingDays === 1 ? 'day' : 'days'}`;
  }

  if (remainingDays === 0) {
    return `${months} ${months === 1 ? 'month' : 'months'}`;
  }

  return `${months} ${months === 1 ? 'month' : 'months'}, ${remainingDays} ${remainingDays === 1 ? 'day' : 'days'}`;
};

export const addDaysToDate = (dateStr, days) => {
  if (!dateStr) return null;
  const d = parseLocalDate(dateStr);
  d.setDate(d.getDate() + days);
  return d;
};
